import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import '@fontsource/source-sans-pro'
import 'assets/font/Roboto/Roboto-Regular.ttf'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { useUIMode } from 'state/application/hooks'
import colors from './colors'
import { palette } from './palette'
import { typography } from './typography'
import { componentsStyle } from './componentsStyle'
import { muiCssBaseline } from './muiCssBaseline'

import { createSvgIcon } from '@mui/material'

export const ArrowDropDownIcon = createSvgIcon(
  <path
    transform="rotate(-180 12 12)"
    id="svg_1"
    fill="white"
    d="m12,6l10,9.796l-2.2499,2.204l-7.7501,-7.5919l-7.75005,7.5919l-2.24995,-2.204l7.75006,-7.59193l-0.00004,-0.00004l2.24998,-2.20403z"
    clipRule="evenodd"
    fillRule="evenodd"
  ></path>,
  'ArrowDropDownIcon'
)

export default function UIModeProvider({ children }: { children: React.ReactNode }) {
  const uiMode = useUIMode()
  const _componentsStyle = componentsStyle(uiMode)
  const _colors = colors(uiMode)
  const themeOptions = {
    palette: {
      mode: uiMode,
      ...palette(uiMode),
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1920,
      },
    },
    shape: {
      borderRadius: 0,
    },
    typography: {
      ...typography,
      button: {
        fontSize: '1rem',
        cursor: 'pointer',
        fontWeight: 600,
      },
    },
    colors: _colors,
    components: {
      ..._componentsStyle,
      MuiCssBaseline: muiCssBaseline(_colors),
    },
  }
  const theme = createTheme(themeOptions)
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
